import React, { useState } from "react";
import { ActivityIndicator, Keyboard } from "react-native";
import { Text, View } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import Separator from "../Separator";
import { CommonButton } from "../../common/CommonButton";
import CommonTextInputWeb from "../../common/CommonTextInputWeb";
import { toast } from "react-toastify";
import { changePassword } from "../../services/authAPI";
import { getLoginData } from "../../utility/AppStoreData";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StackActions, useNavigation } from "@react-navigation/native";
import { base_url, endpoints } from "../../Api/configs";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { clearAllCaches } from "../../utility/cacheManager";

const ChangePasswordTabComponent = ({ accessToken }) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const navigation = useNavigation();
  function userLogoutAPI(props) {
    setShowLoader(true);
    const { bodyParams = {}, success } = props;

    return fetch(base_url + endpoints.auth.logout, {
      mode: "cors",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        body: bodyParams,
      }),
    })
      .then(async function (data) {
        const responce = await data.json();
        const statusCode = data.status;
        setShowLoader(false);
        if (statusCode === 200) {
          success(responce.body);
        } else if (statusCode === 400) {
          toast.error("Bad Request");
        } else if (statusCode > 400 && statusCode < 420) {
          toast.error("Unauthorized");
        } else if (statusCode >= 500) {
          toast.error("Internal Server Error");
        }
      })
      .catch((error) => {
        setShowLoader(false);
        toast.error(error.message);
      });
  }
  const getLoginUserData = async () => {
    try {
      const data = await getLoginData();
      if (data != null) {
        // Clear all caches first - user should be logged out locally regardless of API response
        await clearAllCaches();
        const params = { accessToken: data.AccessToken };
        
        // Try to call logout API, but don't depend on it for local logout
        userLogoutAPI({
          bodyParams: params,
          success: (responseData) => {
            navigation.dispatch(
              StackActions.replace(AppScreens.LoginWebScreen)
            );
          },
        });
      }
    } catch (error) {
      console.error("Logout error:", error);
      // Even if there's an error, still redirect to login since we cleared local data
      navigation.dispatch(
        StackActions.replace(AppScreens.LoginWebScreen)
      );
      toast.error("Logged out locally");
    }
  };
  return (
    <View
      style={{
        backgroundColor: AppColors.purple_453B50,
        borderRadius: 10,
        paddingTop: 20,
        paddingBottom: 30,
        // width:
        //   deviceSize === DEVICE_SIZES.SM ||
        //   deviceSize === DEVICE_SIZES.XS ||
        //   deviceSize === DEVICE_SIZES.MD ||
        //   deviceSize === DEVICE_SIZES.LG
        //     ? "100%"
        //     : 463,
      }}
    >
      <View style={{ marginHorizontal: 20 }}>
        <View
          style={{
            paddingTop:
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? 0
                : 10,
            paddingBottom: 20,
          }}
        >
          <Text style={[AppFontStyle.BOLD_ANYBODY_20, {}]}>
            Change Password
          </Text>
          <Separator
            color={AppColors.green_4CD964}
            height={2}
            marginTop={5}
            marginBottom={0}
            width={"40"}
            marginHorizontal={0}
          />
        </View>
        <View>
          <View style={styles.accountData}>
            <Text style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}>
              Current Password
            </Text>
            <CommonTextInputWeb
              placeholder="Password"
              mainStyle={[styles.accountInputStyle]}
              inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
              prefixIconVisibility={false}
              onChangeText={setPassword}
              isPassword={false}
              value={password}
              onSubmitEditing={() => {
                Keyboard.dismiss();
              }}
              autoCapitalize="none"
              secureTextEntry={true}
              maxLength={50}
            />
          </View>
          <View style={styles.accountData}>
            <Text style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}>
              New Password
            </Text>
            <CommonTextInputWeb
              placeholder="New Password"
              mainStyle={[styles.accountInputStyle]}
              inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
              prefixIconVisibility={false}
              onChangeText={setNewPassword}
              isPassword={false}
              value={newPassword}
              onSubmitEditing={() => {
                Keyboard.dismiss();
              }}
              autoCapitalize="none"
              secureTextEntry={true}
              maxLength={50}
            />
          </View>
          <View style={styles.accountData}>
            <Text style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}>
              Confirm Password
            </Text>
            <CommonTextInputWeb
              placeholder="Confirm Password"
              mainStyle={[styles.accountInputStyle]}
              inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
              prefixIconVisibility={false}
              onChangeText={setConfirmPassword}
              isPassword={false}
              value={confirmPassword}
              onSubmitEditing={() => {
                Keyboard.dismiss();
              }}
              autoCapitalize="none"
              secureTextEntry={true}
              maxLength={50}
            />
          </View>
        </View>
        <View style={{ alignItems: "center" }}>
          <CommonButton
            title={
              showLoader ? (
                <ActivityIndicator
                  size="small"
                  color={AppColors.themeColor_0A89AD}
                />
              ) : (
                "Reset Password"
              )
            }
            textStyle={AppFontStyle.BOLD_ANYBODY_12}
            onTap={async () => {
              if (checkValidation()) {
                const param = {
                  currentPassword: password,
                  newPassword: newPassword,
                  accessToken: accessToken,
                };

                try {
                  setShowLoader(true);

                  const data = await changePassword(param);

                  if (data.statusCode === 200 || data.statusCode === 201) {
                    const errorResponse = JSON.parse(data.body);
                    toast.success(errorResponse.message);
                    await getLoginUserData();
                  } else {
                    const errorResponse = JSON.parse(data.body);
                    toast.error(errorResponse.error || "Reset Password Failed");
                  }
                } catch (error) {
                  toast.error(error.message);
                } finally {
                  setShowLoader(false);
                }
              }
            }}
            buttonStyle={{
              paddingVertical: 14,
              backgroundColor: AppColors.appViolentColor_6D08C3,
              borderRadius: 10,
              shadowOpacity: 0,
              width: 210,
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
              marginTop: 20,
              marginBottom: 0,
            }}
          />
        </View>
      </View>
    </View>
  );

  function checkValidation() {
    if (!password || !newPassword || !confirmPassword) {
      toast.error("Please fill in all fields.");
      return false;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return false;
    }

    return true;
  }
};

export default ChangePasswordTabComponent;

const useStyles = CreateResponsiveStyle(
  {
    infoBox: {
      backgroundColor: AppColors.blue_5575A8,
      paddingTop: 15,
      paddingRight: 15,
      paddingLeft: 31,
      paddingBottom: 31,
      borderRadius: 8,
    },
    accountData: {
      flexDirection: "row",
      gap: 20,
      alignItems: "center",
      marginBottom: 20,
    },
    accountText: {
      width: 87,
      textAlign: "right",
    },
    accountInputStyle: {
      backgroundColor: AppColors.black,
      borderRadius: 10,
      width: 284,
      height: 40,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      accountInputStyle: {
        flex: 1,
        width: "100%",
      },
      accountText: {
        width: "100%",
        textAlign: "left",
      },
      accountData: {
        flexDirection: "column",
        gap: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      accountInputStyle: {
        flex: 1,
        width: "100%",
      },
      accountText: {
        width: "100%",
        textAlign: "left",
      },
      accountData: {
        flexDirection: "column",
        gap: 10,
      },
    },
  }
);
